import React, { Component } from 'react';

export class AuthenticationFailed extends Component {
  constructor() {
    super();
    this.reload = this.reload.bind( this );
  }
  reload() {
    document.location.reload( true );
  }
  render() {
    const{message}=this.props;
    return (
      <div className="failure">
        <div className="dialog">
          <div className="title">
            <h1>Couldn't authenticate request</h1>
          </div>
          <div className="dialog-content">
            <p>
             {message}
            </p>
          </div>
          <div className="controls">
            <a href="#" onClick={ this.reload }>Reload website</a>
          </div>
        </div>
      </div>
    );
  }
}